<template>
  <section id="SMS" class="section-item">
    <h1>Whatsapp</h1>

    <section id="api-Whatsapp-GetWhatsappClient">
      <h2>Whatsapp - {{ $t("title.consult_client") }}</h2>
      <p>{{ $t("wpp.client_data_method") }}</p>
      <div class="">
        <div class="get type">GET</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/whatsapp/client</code></pre>
      </div>
      <div class="code-toggle">
        <button class="json">JSON</button>
        <pre>
          <code class="language-json">{
   "account_id": ""
}</code>
        </pre>

        <h3>{{ $t("general.parameter") }}</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>account_id</td>
              <td>Number</td>
              <td>{{ $t("account.account_id") }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <section id="api-Whatsapp-PostWhatsappClient">
      <h2>Whatsapp - {{ $t("title.create_client") }}</h2>
      <p>{{ $t("wpp.create_client_method") }}</p>
      <div class="">
        <div class="post type">POST</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/whatsapp/client</code></pre>
      </div>
      <div class="code-toggle">
        <button class="curl">JSON</button>
        <pre>
          <code class="language-json">{
   "name": "",
   "email": "",
   "identification": "",
   "password": "",
   "description":"",
   "address": "",
   "category": "",
   "active": false,
   "account_id": "",
   "whatsapp_number": ""
}</code>
        </pre>

        <h3>{{ $t("general.parameter") }}</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>name</td>
              <td>String</td>
              <td>{{ $t("account.client_name") }}</td>
            </tr>
            <tr>
              <td>email</td>
              <td>String</td>
              <td>{{ $t("account.client_email") }}</td>
            </tr>
            <tr>
              <td>identification</td>
              <td>String</td>
              <td>{{ $t("account.client_id") }}</td>
            </tr>
            <tr>
              <td>password</td>
              <td>String</td>
              <td>{{ $t("account.client_password") }}</td>
            </tr>
            <tr>
              <td>description</td>
              <td>String</td>
              <td>{{ $t("account.client_description") }}</td>
            </tr>
            <tr>
              <td>address</td>
              <td>String</td>
              <td>{{ $t("account.client_address") }}</td>
            </tr>
            <tr>
              <td>category</td>
              <td>String</td>
              <td>{{ $t("account.establishment_type") }}</td>
            </tr>
            <tr>
              <td>active</td>
              <td>Boolean</td>
              <td>{{ $t("account.client_active") }}</td>
            </tr>
            <tr>
              <td>account_id</td>
              <td>String</td>
              <td>{{ $t("account.account_id") }}</td>
            </tr>
            <tr>
              <td>whatsapp_number</td>
              <td>String</td>
              <td>{{ $t("account.client_whatsapp_number") }}</td>
            </tr>
          </tbody>
        </table>

        <h3>Success 200</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>scheduled_at</td>
              <td>String</td>
              <td>{{ $t("table.realization_date_time") }}</td>
            </tr>
            <tr>
              <td>from</td>
              <td>String</td>
              <td>{{ $t("table.message_sender") }}</td>
            </tr>
            <tr>
              <td>messages</td>
              <td>Integer</td>
              <td>{{ $t("table.message_quantity") }}</td>
            </tr>
            <tr>
              <td>body</td>
              <td>String</td>
              <td>{{ $t("table.sent_message_content") }}</td>
            </tr>
          </tbody>
        </table>

        <button class="btn02">Sucesso</button>
        <pre>
          <code class="language-json">HTTP/1.1 200 OK
[
 {
   "scheduled_at": "2021-07-05 08:37:19",
   "from": "Default",
   "messages": 1,
   "body": "Hi,\n\nYour account has been created!\n\nThanks. "
 }
]</code>
        </pre>

        <button class="btn02">Error-Response</button>
        <pre>
          <code class="language-json">{
    "error": "Error message"
  }</code>
        </pre>
      </div>
    </section>

    <section id="api-Whatsapp-PostWhatsappTemplates">
      <h2>Whatsapp - {{ $t("title.create_template") }}</h2>
      <p>{{ $t("wpp.create_template_method") }}</p>
      <div class="">
        <div class="post type">POST</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/whatsapp/templates</code></pre>
      </div>

      <pre>
          <code class="language-json">{
   "name": "",
   "body": "",
   "footer": "",
   "account_id": "",
   "type": ""
}</code>
        </pre>

      <h3>{{ $t("general.parameter") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>name</td>
            <td>String</td>
            <td>{{ $t("table.template_name") }}</td>
          </tr>
          <tr>
            <td>body</td>
            <td>String</td>
            <td>{{ $t("table.template_content") }}</td>
          </tr>
          <tr>
            <td>footer</td>
            <td>String</td>
            <td>{{ $t("table.template_footer") }}</td>
          </tr>
          <tr>
            <td>account_id</td>
            <td>String</td>
            <td>{{ $t("account.account_id") }}</td>
          </tr>
          <tr>
            <td>type</td>
            <td>String</td>
            <td>{{ $t("table.template_type") }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <section id="api-Whatsapp-PostWhatsappMessages">
      <h2>Whatsapp - {{ $t("title.send_message") }}</h2>
      <p>{{ $t("wpp.send_message_method") }}</p>
      <div class="">
        <div class="post type">POST</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/whatsapp/messages</code></pre>
      </div>

      <!-- <pre>
          <code class="language-json">{
  "messages": [
    {
      "type": "simple",
      "from": "Default",
      "ext_id" : "d6ae70de-ec06-4a47-b1b4-ba25e6d2320d3",
      "to": "556196426188",
      "body": "Hi,\n\nYour account has been created!\n\nThanks. ",
      "template": {
         "id": "d6ae70de-ec06-4a47-b1b4-ba25e6da80d3",
         "name": "new_account"
      },
      "params": []
    }
  ]
}</code>
</pre> -->
      <pre>
          <code class="language-json">{
  "messages": [
    {
      "type": "simple",
      "from": "Default",
      "ext_id": "d6ae70de-ec06-4a47-b1b4-ba25e6d2320d3",
      "to": "5513996958183",
      "body": "Hi,\n\nYour account has been created!\n\nThanks.",
      "template": {
        "id": "d6ae70de-ec06-4a47-b1b4-ba25e6da80d3",
        "name": "new_account"
      },
      "params": [],
      "status_callback": "https://example.com/status_callback",
      "message_callback": "https://example.com/message_callback"
    },
    {
      "type": "text",
      "from": "Default",
      "to": "5513996958183",
      "body": "Hi,\n\nYour account has been created!\n\nThanks.",
      "status_callback": "https://example.com/status_callback",
      "message_callback": "https://example.com/message_callback"
    },
    {
      "type": "image",
      "from": "Default",
      "to": "5513996958183",
      "body": "Hi,\n\nYour account has been created!\n\nThanks.",
      "url": "https://example.com/image.jpg",
      "status_callback": "https://example.com/status_callback",
      "message_callback": "https://example.com/message_callback"
    },
    {
      "type": "video",
      "from": "Default",
      "to": "5513996958183",
      "body": "Hi,\n\nYour account has been created!\n\nThanks.",
      "url": "https://example.com/video.mp4",
      "status_callback": "https://example.com/status_callback",
      "message_callback": "https://example.com/message_callback"
    },
    {
      "type": "interactive",
      "from": "Default",
      "to": "5513996958183",
      "body": "Hi,\n\nYour account has been created!\n\nThanks.",
      "interaction": {
        "type": "button",
        "actions": [
          {
            "title": "Click here",
            "payload": "button"
          }
        ]
      },
      "status_callback": "https://example.com/status_callback",
      "message_callback": "https://example.com/message_callback"
    }
  ]
}
</code>
</pre>

      <h3>{{ $t("general.parameter") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>messages</td>
            <td>Array</td>
            <td>{{ $t("table.message_set") }}</td>
          </tr>
          <tr>
            <td>type</td>
            <td>String</td>
            <td>Tipo da mensagem (simple, text, image, video, interactive).</td>
          </tr>
          <tr>
            <td>from</td>
            <td>String</td>
            <td>{{ $t("table.message_sender") }}</td>
          </tr>
          <tr>
            <td>ext_id</td>
            <td>String</td>
            <td>{{ $t("table.external_id-wpp") }}</td>
          </tr>
          <tr>
            <td>to</td>
            <td>String</td>
            <td>{{ $t("table.message_recipient") }}</td>
          </tr>
          <tr>
            <td>body</td>
            <td>String</td>
            <td>{{ $t("table.message_body") }}</td>
          </tr>
          <tr>
            <td>template</td>
            <td>Object</td>
            <td>{{ $t("table.used_template") }}</td>
          </tr>
          <tr>
            <td>id</td>
            <td>String</td>
            <td>{{ $t("table.template_id") }}</td>
          </tr>
          <tr>
            <td>name</td>
            <td>String</td>
            <td>{{ $t("table.template_name") }}</td>
          </tr>
          <tr>
            <td>params</td>
            <td>Array</td>
            <td>{{ $t("table.sending_parameters") }}</td>
          </tr>
          <tr>
            <td>url</td>
            <td>String</td>
            <td>{{ $t("table.media_url") }}</td>
          </tr>
          <tr>
            <td>status_callback</td>
            <td>String</td>
            <td>{{ $t("table.status_callback_url") }}</td>
          </tr>
          <tr>
            <td>message_callback</td>
            <td>String</td>
            <td></td>
          </tr>
        </tbody>
      </table>

      <h3>Tipos de Mensagem</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>text</td>
            <td>String</td>
            <td>{{ $t("table.text_message") }}</td>
          </tr>
          <tr>
            <td>image</td>
            <td>String</td>
            <td>{{ $t("table.image_message") }}</td>
          </tr>
          <tr>
            <td>video</td>
            <td>String</td>
            <td>{{ $t("table.video_message") }}</td>
          </tr>
          <tr>
            <td>interactive</td>
            <td>String</td>
            <td>{{ $t("table.interactive_message") }}</td>
          </tr>
        </tbody>
      </table>

      <h3>URL</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>url</td>
            <td>String</td>
            <td>{{ $t("table.media_url-wpp") }}</td>
          </tr>
        </tbody>
      </table>

      <h3>Interação</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>interaction</td>
            <td>Object</td>
            <td>{{ $t("table.interaction_object") }}</td>
          </tr>
          <tr>
            <td>type</td>
            <td>String</td>
            <td>{{ $t("table.interaction_type") }}</td>
          </tr>
          <tr>
            <td>actions</td>
            <td>array</td>
            <td>{{ $t("table.interaction_actions_array") }}</td>
          </tr>
          <tr>
            <td>title</td>
            <td>String</td>
            <td>{{ $t("table.action_title") }}</td>
          </tr>
          <tr>
            <td>payload</td>
            <td>String</td>
            <td>{{ $t("table.action_payload") }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <section id="api-Whatsapp-DeleteWhatsappTemplatesId">
      <h2>Whatsapp - {{ $t("title.delete_template") }}</h2>
      <p>{{ $t("wpp.delete_template_method") }}</p>
      <div class="">
        <div class="delete type">DELETE</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/whatsapp/templates/:id</code></pre>
      </div>

      <pre>
          <code class="language-json">{
   "account_id": ""
}</code>
        </pre>

      <h3>{{ $t("general.parameter") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tr>
          <td>account_id</td>
          <td>String</td>
          <td>{{ $t("account.account_id") }}</td>
        </tr>
        <tr>
          <td>id</td>
          <td>String</td>
          <td>{{ $t("table.template_id") }}</td>
        </tr>
      </table>
    </section>

    <section id="api-Whatsapp-PostWhatsappMessagesList">
      <h2>Whatsapp - {{ $t("title.list_messages") }}</h2>
      <p>{{ $t("wpp.list_messages_method") }}</p>
      <div class="">
        <div class="post type">POST</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/whatsapp/messages/list</code></pre>
      </div>

      <pre>
          <code class="language-json">{
   "account_id": ""
}</code>
        </pre>

      <h3>{{ $t("general.parameter") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>account_id</td>
            <td>String</td>
            <td>{{ $t("account.account_id") }}</td>
          </tr>
        </tbody>
      </table>

      <h3>Success 200</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>messages</td>
            <td>Array</td>
            <td>{{ $t("table.sent_message_set") }}</td>
          </tr>
          <tr>
            <td>type</td>
            <td>String</td>
            <td>{{ $t("table.message_type") }}</td>
          </tr>
          <tr>
            <td>from</td>
            <td>String</td>
            <td>{{ $t("table.message_sender") }}</td>
          </tr>
          <tr>
            <td>ext_id</td>
            <td>String</td>
            <td>{{ $t("table.external_id-client") }}</td>
          </tr>
          <tr>
            <td>to</td>
            <td>String</td>
            <td>{{ $t("table.message_recipient") }}</td>
          </tr>
          <tr>
            <td>body</td>
            <td>String</td>
            <td>{{ $t("table.message_body") }}</td>
          </tr>
          <tr>
            <td>template</td>
            <td>Object</td>
            <td>{{ $t("table.used_template") }}</td>
          </tr>
          <tr>
            <td>name</td>
            <td>String</td>
            <td>{{ $t("table.template_name") }}</td>
          </tr>
          <tr>
            <td>params</td>
            <td>Array</td>
            <td>{{ $t("table.sending_parameters") }}</td>
          </tr>
        </tbody>
      </table>

      <button class="btn02">Sucesso</button>
      <pre>
          <code class="language-json">HTTP/1.1 200 OK
{
  "messages": [
    {
      "type": "simple",
      "from": "Default",
      "ext_id" : "d6ae70de-ec06-4a47-b1b4-ba25e6d2320d3",
      "to": "556196426188",
      "body": "Hi,\n\nYour account has been created!\n\nThanks.",
      "template": {
        "type": "text",
        "name": "new_account"
      },
      "params": []
    }
  ]
}</code>
        </pre>
    </section>

    <section id="api-Whatsapp-GetWhatsappTemplatesList">
      <h2>Whatsapp - {{ $t("title.list_templates") }}</h2>
      <p>{{ $t("general.list_templates_method") }}</p>
      <div class="">
        <div class="get type">GET</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/whatsapp/templates/list</code></pre>
      </div>

      <pre>
          <code class="language-json">{
   "account_id": ""
}</code>
        </pre>

      <h3>{{ $t("general.parameter") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>account_id</td>
            <td>String</td>
            <td>{{ $t("account.account_id") }}</td>
          </tr>
        </tbody>
      </table>
    </section>
  </section>
</template>

<script>
import hljs from "highlight.js";
import "highlight.js/styles/an-old-hope.css";

export default {
  name: "WppComponent",
  data() {
    return {
      selectedTab: "json",
    };
  },
  mounted() {
    this.highlightCode();
  },
  watch: {
    selectedTab() {
      this.$nextTick(() => {
        this.highlightCode();
      });
    },
  },
  methods: {
    highlightCode() {
      document.querySelectorAll("pre code").forEach((block) => {
        hljs.highlightBlock(block);
      });
    },
  },
};
</script>

<style scoped>
.sms-section {
  margin-top: 30px;
  text-align: start;
}

.sms-method {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1rem;
}

pre[class*="language-"] {
  background-color: #000 !important;
  color: var(--green-code);
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  overflow-x: auto;
  white-space: pre-wrap;
  font-family: var(--font-code);
  margin-bottom: 20px;
}
</style>
